module.exports = __webpack_public_path__ + "static/media/Car.804fe655.svg";